import { render, staticRenderFns } from "./TransactionCommentsView.vue?vue&type=template&id=682c3d2e"
import script from "./TransactionCommentsView.vue?vue&type=script&lang=js"
export * from "./TransactionCommentsView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports